import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { CustomerDutyAudit } from '../../+models/company-profile-audit.model';

@Component({
  selector: 'sd-portal-customer-duty-audit-list',
  templateUrl: './customer-duty-audit-list.component.html',
  styleUrls: ['./customer-duty-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomerDutyAuditListComponent implements OnInit {
  @Input() customerDutyId: number;
  @Input() loading: boolean;
  @Input() customerDutyAudits: CustomerDutyAudit[];

  @Output() loadCustomerDuty = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadCustomerDuty.emit(this.customerDutyId);
  }

  onNextPage() {
    this.nextPage.emit(this.customerDutyId);
  }
}
